/* eslint no-param-reassign: ["error", { "props": false }] */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// view types
export enum View {
    Activities = "Activities",
    Bookings = "Bookings",
    Calendar = "Calendar",
    Club = "Club",
    Courts = "Courts",
    Documents = "Documents",
    EmbeddedSIPForm = "EmbeddedSIPForm",
    GuestCheckin = "GuestCheckin",
    Home = "Home",
    Members = "Members",
    OwnerSignup = "OwnerSignup",
    Profile = "Profile",
    Welcome = "Welcome",
    CompanySignup = "CompanySignup",
    B2BFeatures = "B2BFeatures",
    Challenge = "Challenge",
}

// user state
interface GlobalState {
    currentTab: number,
    urlData: { [x: string]: string },
    view: View,
    isCompanyProfile: boolean,
}

// initial state
const initialState: GlobalState = {
    currentTab: 0,
    urlData: {},
    view: View.Calendar,
    isCompanyProfile: false,
};

// slice
const globalSlice = createSlice({
    name: "global",
    initialState,
    reducers: {
        navigateTo: (state, { payload }: PayloadAction<View | { view: View, tab?: number }>) => {
            if (typeof payload === "string") {
                state.view = payload as View;
            } else {
                state.view = (payload as { view: View, tab?: number }).view;
                state.currentTab = (payload as { view: View, tab?: number }).tab || 0;
            }
        },
        setCurrentTab: (state, { payload }: PayloadAction<number>) => { state.currentTab = payload; },
        setUrlData: (state, { payload }: PayloadAction<GlobalState["urlData"]>) => { state.urlData = payload; },
    },
});

// inferred actions
export const { navigateTo, setCurrentTab, setUrlData } = globalSlice.actions;

export default globalSlice.reducer;
